import { getClient } from "entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios/functions"
import _ from 'lodash'

export default async function LBMGraficoExtraRelatorio(
    content,
    h,
    mediaAgrupadorList,
    metaUsar,
    IndicadorEntity,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
) {
    let grupo = mediaAgrupadorList[0]

    // obtém percentagem de brocas internas e verifica o status
    let mediaBrocasInternas = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'percentBrocasInternas', 0)))
    grupo.mediaBrocasInternas = mediaBrocasInternas.toFixed(2) // conformidade adultas por metro
    if (paramsCliente) { // status e cor adultas por metro
        grupo.statusBrocasInternas = IndicadorEntity.getConformidadeStatus(mediaBrocasInternas, paramsCliente.metaMaxAdultas, null, getClient())
        grupo.colorBrocasInternas = IndicadorEntity.getColorStatus(grupo.statusBrocasInternas)
    }


    content.push(
        h.pageBreak(),
        h.panel(
            [
                h.row(
                    h.title('Brocas Internas', { fontSize: 12 }),
                ),
            ],
            { widths: ["*"], unbreakable: true }
        ),
        h.tablePanel([
            { title: "Agrupador", value: groupByConfig.nome },
            { title: "Meta Brocas Internas", value: paramsCliente?.metaBrocasInternas || '' },
            { title: "Data de Início", value: dataInicio },
            { title: "Data de Fim", value: dataFim },
        ]),
        h.panel(
            [
                h.row(
                    await h.chart(
                        "CardIndicadorProps",
                        {
                            xField: "groupNameShow",
                            yField: "mediaBrocasInternas",
                            data: mediaAgrupadorList,
                            meta: parseFloat(paramsCliente?.metaBrocasInternas),
                            width: 525,
                            height: 400,
                            color: mediaAgrupadorList.map(m => m.colorBrocasInternas),
                            colorFieldPath: 'colorBrocasInternas'
                        },
                        { alignment: "center" }
                    ),
                ),
            ],
            { widths: ["*"], unbreakable: true, layout: "borders" }
        ),
        h.tablePanel(
            [
                { title: groupByConfig.nome, field: "groupNameShow" },
                { title: "Média", field: "mediaBrocasInternas" },
                { title: "Status", field: "statusBrocasInternas" },
            ],
            mediaAgrupadorList
        ),
    )
}